import React, { Suspense, useContext } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import "./helpers/interceptor";
import Loader from "./components/layouts/partials/Loader";
import DashboardLayout from "./components/layouts/Dashboard";
import UserState from "./context/users/userState";
import EventState from "./context/events/eventState";
import ParticipantState from "./context/participants/participantState";
import AttendanceState from "./context/attendance/attendanceState";
import FollowUpState from "./context/followup/followUpState";
import ResourceState from "./context/resource/resourceState";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ResourceContext from "./context/resource/resourceContext";
import { WHATSAPP_ENABLED } from "./helpers/features";

const Login = React.lazy(() => import("./pages/auth/Login"));
const Reset = React.lazy(() => import("./pages/auth/Reset"));
const DashboardDB = React.lazy(() => import("./pages/dashboard/Dashboard"));
const ParticipantsDB = React.lazy(() =>
  import("./pages/dashboard/participants/Participants")
);
const ParticipantDetailsDB = React.lazy(() =>
  import("./pages/dashboard/participants/Details")
);
const ParticipantsSendMail = React.lazy(() => import("./pages/dashboard/participants/SendMail"));
const ParticipantsSendSMS = React.lazy(() => import("./pages/dashboard/participants/SendSMS"));
const ParticipantsSendWhatsApp = React.lazy(() =>
  import("./pages/dashboard/participants/SendWhatsApp")
);
const ParticipantAttendanceHistoryDB = React.lazy(() => import("./pages/dashboard/participants/AttendanceHistory"));
const ParticipantFollowUpsDB = React.lazy(() => import("./pages/dashboard/participants/FollowUps"));
const AccomodationsDB = React.lazy(() =>
  import("./pages/dashboard/accomodations/Accomodations")
);
const RoomsDB = React.lazy(() =>
  import("./pages/dashboard/accomodations/Rooms")
);
const ViewRoomDB = React.lazy(() =>
  import("./pages/dashboard/accomodations/ViewRoom")
);
const AddRoomsDB = React.lazy(() =>
  import("./pages/dashboard/accomodations/AddRoom")
);
const EditRoomsDB = React.lazy(() =>
  import("./pages/dashboard/accomodations/EditRoom")
);
const AddAccomodationDB = React.lazy(() => import("./pages/dashboard/accomodations/AddAccomodation"));
const EditAccomodationDB = React.lazy(() => import("./pages/dashboard/accomodations/EditAccomodation"));
const SessionsDB = React.lazy(() => import("./pages/dashboard/sessions/Sessions"));
const EventSetupDB = React.lazy(() => import("./pages/dashboard/setup/EventSetup"));
const ReportsDB = React.lazy(() => import("./pages/dashboard/reports/Reports"));
const CenterReportsDB = React.lazy(() => import("./pages/dashboard/reports/CenterReport"));
const CenterReportDetailsDB = React.lazy(() => import("./pages/dashboard/reports/ReportDetails"));
const CenterDownloadReportDB = React.lazy(() => import("./pages/dashboard/reports/DownloadReport"));
const AddCenterReportDB = React.lazy(() => import("./pages/dashboard/reports/AddCenterReport"));
const TransactionReportDB = React.lazy(() => import("./pages/dashboard/reports/TransactionReport"));
const AttendanceReportDB = React.lazy(() => import("./pages/dashboard/reports/AttendanceReport"));
const PeopleDB = React.lazy(() => import("./pages/dashboard/reports/People"));
const FollowUpsReportDB = React.lazy(() =>
  import("./pages/dashboard/reports/FollowUps")
);
const RegistrationsDB = React.lazy(() =>
  import("./pages/dashboard/reports/Registrations")
);
const PersonHistoryDB = React.lazy(() => import("./pages/dashboard/reports/PersonHistory"));

const EventsDB = React.lazy(() => import("./pages/dashboard/events/Events"));
const EventStatDB = React.lazy(() => import("./pages/dashboard/events/EventStat"));
const AddEventsDB = React.lazy(() => import("./pages/dashboard/events/AddEvent"));
const EditEventsDB = React.lazy(() => import("./pages/dashboard/events/EditEvent"));

const ResourceGroupsDB = React.lazy(() =>
  import("./pages/dashboard/resource/ResourceGroups")
);
const UsersDB = React.lazy(() => import("./pages/dashboard/users/Users"));
const AddUserDB = React.lazy(() => import("./pages/dashboard/users/AddUser"));
const EditUserDB = React.lazy(() => import("./pages/dashboard/users/EditUser"));
const AccountsDB = React.lazy(() =>
  import("./pages/dashboard/users/Accounts")
);
const ShortLinksDB = React.lazy(() =>
  import("./pages/dashboard/links/ShortLinks")
);

const App = () => {
  const resourceContext = useContext(ResourceContext)


  return (
    <Router>
      <UserState>
        <EventState>
          <ParticipantState>
          <AttendanceState>
          <FollowUpState>
          <ResourceState>
            <ToastContainer />

            <Suspense fallback={Loader()}>
              <Routes>
                {/* Auth */}
                <Route path="/" exact element={<Login />} />
                <Route path="/login" exact element={<Login />} />
                <Route path="/reset" element={<Reset />} />

                {/* Dashboard */}
                <Route
                  path="/dashboard"
                  element={
                    <DashboardLayout
                      Component={DashboardDB}
                      header="Dashboard"
                      text="Manage all activities"
                      show={resourceContext?.showSelect}
                    />
                  }
                />

                {/* Event routes */}

                <Route
                  path="/dashboard/events"
                  element={
                    <DashboardLayout
                      Component={EventsDB}
                      header="Events"
                      text="Manage all events"
                      show={resourceContext?.showSelect}
                    />
                  }
                />

                <Route
                  path="/dashboard/events/stat/:id"
                  element={
                    <DashboardLayout
                      Component={EventStatDB}
                      header="Events"
                      text="View all statistics about this event"
                      show={resourceContext?.showSelect}
                    />
                  }
                />

                <Route
                  path="/dashboard/events/create"
                  element={
                    <DashboardLayout
                      Component={AddEventsDB}
                      header="Event"
                      text="Create New Event"
                      show={resourceContext?.showSelect}
                    />
                  }
                />

                <Route
                  path="/dashboard/events/:id"
                  element={
                    <DashboardLayout
                      Component={EditEventsDB}
                      header="Update Event"
                      text="Update Event"
                      show={resourceContext?.showSelect}
                    />
                  }
                />

                <Route
                  path="/dashboard/participants"
                  element={
                    <DashboardLayout
                      Component={ParticipantsDB}
                      header="Participants"
                      text="Manage all participants"
                      show={resourceContext?.showSelect}
                    />
                  }
                />

                <Route
                  path="/dashboard/participants/:id"
                  element={
                    <DashboardLayout
                      Component={ParticipantDetailsDB}
                      header="Participants"
                      text="Manage participant"
                      show={resourceContext?.showSelect}
                    />
                  }
                />

                <Route
                  path="/dashboard/participants/send-email"
                  element={
                    <DashboardLayout
                      Component={ParticipantsSendMail}
                      header="Send Email"
                      text="Manage participant"
                      show={resourceContext?.showSelect}
                    />
                  }
                />

                {WHATSAPP_ENABLED && (
                  <Route
                    path="/dashboard/participants/send-whatsapp"
                    element={
                      <DashboardLayout
                        Component={ParticipantsSendWhatsApp}
                        header="Send WhatsApp"
                        text="Manage participant"
                        show={resourceContext?.showSelect}
                      />
                    }
                  />
                )}

                <Route
                  path="/dashboard/participants/send-sms"
                  element={
                    <DashboardLayout
                      Component={ParticipantsSendSMS}
                      header="Send SMS"
                      text="Manage participant"
                      show={resourceContext?.showSelect}
                    />
                  }
                />

                <Route
                  path="/dashboard/participants/:id/attendance-history"
                  element={
                    <DashboardLayout
                      Component={ParticipantAttendanceHistoryDB}
                      header="Attendance History"
                      text="View participant attendance history"
                      show={resourceContext?.showSelect}
                    />
                  }
                />

                <Route
                  path="/dashboard/participants/:id/follow-ups"
                  element={
                    <DashboardLayout
                      Component={ParticipantFollowUpsDB}
                      header="Follow Up Records"
                      text="View participant follow up records"
                      show={resourceContext?.showSelect}
                    />
                  }
                />
                <Route
                  path="/dashboard/setup"
                  element={
                    <DashboardLayout
                      Component={EventSetupDB}
                      header="Event setup"
                      text="Get an event ready to take check-ins"
                      show={resourceContext?.showSelect}
                    />
                  }
                />
                <Route
                  path="/dashboard/sessions"
                  element={
                    <DashboardLayout
                      Component={SessionsDB}
                      header="Sessions"
                      text="Manage all sessions"
                      show={resourceContext?.showSelect}
                    />
                  }
                />
                <Route
                  path="/dashboard/reports"
                  element={
                    <DashboardLayout
                      Component={ReportsDB}
                      header="Reports"
                      text="Manage all activities"
                      show={resourceContext?.showSelect}
                    />
                  }
                />
                <Route
                  path="/dashboard/reports/center"
                  element={
                    <DashboardLayout
                      Component={CenterReportsDB}
                      header="Reports"
                      text="Manage all center reports"
                      show={resourceContext?.showSelect}
                    />
                  }
                />
                <Route
                  path="/dashboard/reports/center/:id"
                  element={
                    <DashboardLayout
                      Component={CenterReportDetailsDB}
                      header="Reports"
                      text="View center report details"
                      show={resourceContext?.showSelect}
                    />
                  }
                />
                <Route
                  path="/dashboard/reports/center/download/:id"
                  element={
                    <DashboardLayout
                      Component={CenterDownloadReportDB}
                      header="Reports"
                      text="Download center report details"
                      show={resourceContext?.showSelect}
                    />
                  }
                />
                <Route
                  path="/dashboard/reports/center/create"
                  element={
                    <DashboardLayout
                      Component={AddCenterReportDB}
                      header="Reports"
                      text="Add new center report"
                      show={resourceContext?.showSelect}
                    />
                  }
                />

                  }
                />
                  }
                />
                {/* People, and one person's history across events. The id
                    may be an account id or an email, so it is matched
                    loosely rather than as a Mongo id. */}
                <Route
                  path="/dashboard/reports/registrations"
                  element={
                    <DashboardLayout
                      Component={RegistrationsDB}
                      header="Registrations"
                      text="Who signed up for an event"
                      show={resourceContext?.showSelect}
                    />
                  }
                />
                <Route
                  path="/dashboard/reports/follow-ups"
                  element={
                    <DashboardLayout
                      Component={FollowUpsReportDB}
                      header="Follow-ups"
                      text="Who has been contacted since an event"
                      show={resourceContext?.showSelect}
                    />
                  }
                />
                <Route
                  path="/dashboard/reports/people"
                  element={
                    <DashboardLayout
                      Component={PeopleDB}
                      header="People"
                      text="Everyone who has ever registered"
                      show={resourceContext?.showSelect}
                    />
                  }
                />
                <Route
                  path="/dashboard/reports/people/:id"
                  element={
                    <DashboardLayout
                      Component={PersonHistoryDB}
                      header="People"
                      text="Participation history"
                      show={resourceContext?.showSelect}
                    />
                  }
                />
                <Route
                  path="/dashboard/reports/attendance-report"
                  element={
                    <DashboardLayout
                      Component={AttendanceReportDB}
                      show={resourceContext?.showSelect}
                    />
                  }
                />
                <Route
                  path="/dashboard/reports/transactions-report"
                  element={
                    <DashboardLayout
                      Component={TransactionReportDB}
                      show={resourceContext?.showSelect}
                    />
                  }
                />

                <Route
                  path="/dashboard/resource-groups"
                  element={
                    <DashboardLayout
                      Component={ResourceGroupsDB}
                      header="Resource Groups"
                      text="Manage all resource groups"
                      show={resourceContext?.showSelect}
                    />
                  }
                />
                  }
                />
                <Route
                  path="/dashboard/accomodations"
                  element={
                    <DashboardLayout
                      Component={AccomodationsDB}
                      header="Accomodation Units"
                      text="Manage all accomodation"
                      show={resourceContext?.showSelect}
                    />
                  }
                />
                <Route
                  path="/dashboard/accomodations/add"
                  element={
                    <DashboardLayout
                      Component={AddAccomodationDB}
                      header="Create Accomodation Unit"
                      text="Add new accomodation Unit"
                      show={resourceContext?.showSelect}
                    />
                  }
                />
                <Route
                  path="/dashboard/accomodations/:id"
                  element={
                    <DashboardLayout
                      Component={EditAccomodationDB}
                      header="Edit Accomodation Unit"
                      text="edit accomodation unit details"
                      show={resourceContext?.showSelect}
                    />
                  }
                />
                <Route
                  path="/dashboard/accomodation/rooms/:id"
                  element={
                    <DashboardLayout
                      Component={RoomsDB}
                      header="Rooms"
                      text="Manage all rooms"
                      show={resourceContext?.showSelect}
                    />
                  }
                />
                {/* Who is in one room — reachable from the room list. */}
                <Route
                  path="/dashboard/accomodation/room/:id"
                  element={
                    <DashboardLayout
                      Component={ViewRoomDB}
                      header="Room"
                      text="Who is in this room"
                      show={resourceContext?.showSelect}
                    />
                  }
                />
                <Route
                  path="/dashboard/accomodation/rooms/add/:id"
                  element={
                    <DashboardLayout
                      Component={AddRoomsDB}
                      header="Create Room"
                      text="Add new room"
                      show={resourceContext?.showSelect}
                    />
                  }
                />
                <Route
                  path="/dashboard/accomodations/rooms/edit/:id"
                  element={
                    <DashboardLayout
                      Component={EditRoomsDB}
                      header="Edit Room"
                      text="Update room details"
                      show={resourceContext?.showSelect}
                    />
                  }
                />
                <Route
                  path="/dashboard/users"
                  element={
                    <DashboardLayout
                      Component={UsersDB}
                      header="Users"
                      text="Manage all users"
                      show={resourceContext?.showSelect}
                    />
                  }
                />
                <Route
                  path="/dashboard/short-links"
                  element={
                    <DashboardLayout
                      Component={ShortLinksDB}
                      header="Short links"
                      text="The tarm.cc links on flyers and in broadcasts, and how often each is followed"
                      show={resourceContext?.showSelect}
                    />
                  }
                />
                <Route
                  path="/dashboard/users/accounts"
                  element={
                    <DashboardLayout
                      Component={AccountsDB}
                      header="Attendee accounts"
                      text="The accounts people sign in with"
                      show={resourceContext?.showSelect}
                    />
                  }
                />
                <Route
                  path="/dashboard/users/create"
                  element={
                    <DashboardLayout
                      Component={AddUserDB}
                      header="Users"
                      text="Create new user"
                      show={resourceContext?.showSelect}
                    />
                  }
                />
                <Route
                  path="/dashboard/users/edit/:id"
                  element={
                    <DashboardLayout
                      Component={EditUserDB}
                      header="User"
                      text="Update user details"
                      show={resourceContext?.showSelect}
                    />
                  }
                />
              </Routes>
            </Suspense>
          </ResourceState>
          </FollowUpState>
          </AttendanceState>
          </ParticipantState>
        </EventState>
      </UserState>
    </Router>
  );
};

export default App;
